/**
 * 🧭 상단 헤더 — 전역 검색 · 최근 본 항목 · ★ 즐겨찾기 · 🔔 알림 수 (v2.319.0 · backend /nav 와 1:1)
 */
import { api } from './api';

export interface SearchItem { id: string; title: string; sub: string; path: string }
export interface SearchGroup { kind: string; label: string; items: SearchItem[] }
export async function navSearch(q: string): Promise<SearchGroup[]> {
  const r = await api.get<{ q: string; groups: SearchGroup[] }>(`/nav/search?q=${encodeURIComponent(q)}`);
  return r.groups;
}

export type RecentKind = 'sales' | 'partner' | 'deal' | 'maintenance' | 'page';
export interface RecentItem { kind: RecentKind; refId: string; label: string; path: string; viewedAt: string }
export async function listRecent(): Promise<RecentItem[]> {
  return (await api.get<{ items: RecentItem[] }>('/nav/recent')).items;
}
/** 본 것 기록 — 실패해도 화면은 모른 척(알림이 아니라 편의 기능) */
export function recordRecent(item: { kind: RecentKind; refId: string; label: string; path: string }): void {
  void api.post('/nav/recent', item).catch(() => undefined);
}

export interface Favorite { id: number; path: string; label: string }
export async function listFavorites(): Promise<Favorite[]> {
  return (await api.get<{ items: Favorite[] }>('/nav/favorites')).items;
}
export async function addFavorite(path: string, label: string): Promise<Favorite> {
  return api.post<Favorite>('/nav/favorites', { path, label });
}
export async function removeFavorite(path: string): Promise<void> {
  await api.delete<{ deleted: number }>(`/nav/favorites?path=${encodeURIComponent(path)}`);
}

export interface BellItem { key: string; label: string; count: number; path: string; tone: 'err' | 'warn' | 'info' }
/** 🔔 — items = 종에 띄울 것(숨긴 항목은 서버가 뺐다) · choices = 이 계정이 고를 수 있는 것 · hidden = 숨긴 key (v2.323.0 · #34) */
export interface BellCounts { today: string; items: BellItem[]; choices: { key: string; label: string }[]; hidden: string[] }
export async function bellCounts(): Promise<BellCounts> {
  return api.get<BellCounts>('/nav/bell');
}

export const RECENT_KIND_LABEL: Record<RecentKind, string> = { sales: '영업건', partner: '거래처', deal: '딜등록', maintenance: '유지보수', page: '화면' };
